import { render, staticRenderFns } from "./PostTypeShow.vue?vue&type=template&id=5c0a429f&scoped=true&"
import script from "./PostTypeShow.vue?vue&type=script&lang=js&"
export * from "./PostTypeShow.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PostTypeShow.vue?vue&type=style&index=0&id=5c0a429f&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5c0a429f",
  "cdc29c08"
  
)

export default component.exports